module.exports = __webpack_public_path__ + "static/media/logo@2x.8b6d9ee6.png";